import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useForm, useRouter } from '~/hooks';
import { Card } from '~/components';
import FormGroup from '~/components/form/form-group';
import FormPassword from '~/components/form/form-password';
import FormError from '~/components/form/form-error';
import TryonExpressLogo from '~/assets/img/tryonexpress-logo.png';
import { MdCall, MdMailOutline } from 'react-icons/md';
import { Link, Redirect } from 'react-router-dom';
import {  resetPasswordRequest  } from '~/api';
import { auth as authUtil } from '~/util';

const ResetPasswordPage = () => {

    const { params, history } = useRouter();
    const { token } = params;

    const [user, setUser] = useState({});
    const [unauthorized, setUnauthorized] = useState(false);

    const onSubmit = async ({ values, onFail, onInvalidForm, resetFormErrors }) => {
        try {
            resetFormErrors();

            let errors = {};

            if (!values.password) errors.password = 'Password is required';
            if (!values.confirmPassword) errors.confirmPassword = 'Confirm password is required';
            if (values.password !== values.confirmPassword){
                errors.confirmPassword = 'Password and Confirm password must match';
            }
            if (!isEmpty(errors)) return onInvalidForm(errors);
            await resetPasswordRequest.updatePassword(token, values.password, values.confirmPassword);

            history.push('/login');

        } catch (e) {
            return onFail(e.message);
        }
    };

    const {
        state,
        formActions,
        fieldActions
    } = useForm({
        initialState: {
            password: '',
            confirmPassword: ''
        },
        onSubmit
    });

    useEffect(async ()=>{
        const _user = await resetPasswordRequest.validateResetPasswordToken(token);

        if (_user) {
            setUser(_user);
        } else {
            setUnauthorized(true);
        }
    },[token]);    

    return unauthorized 
        ? <Redirect to='/' replace /> 
        : (
            <div className="h-screen w-screen bg-gradient-to-b from-blue-50 to-blue-60 flex flex-col items-center justify-center p-8 md:p-12 lg:px-10 lg:py-36">
                <Card className="h-screen flex-1 flex flex-col lg:flex-row-reverse items-stretch w-11/12 lg:w-5/6 xl:w-2/3 justify-items-stretch">
                    <div className="bg-login flex-1 lg:flex-initial lg:w-1/2 bg-center bg-no-repeat bg-cover"/> 
                    <section className="flex-grow lg:w-1/2 flex flex-col items-stretch justify-center p-8 lg:p-16">
                        <img src={TryonExpressLogo} className="h-16 self-start mb-4 ml-1"/>
                        <p className="font-semibold text-sm lg:text-base xl:text-lg mb-1">Residential &amp; Commercial Title Service Company</p>
                        <p className="text-gray-410 text-xs lg:text-sm mb-4">From Mountain to Coast, Serving all 100 North Carolina Counties</p>
                        <p className="text-sm font-semibold mb-2">Reset Password</p>
                        <FormGroup 
                            placeholder="Username"
                            path="username"
                            readOnly
                            inputClassName="disabled:bg-gray-150 disabled:text-gray-410 text-sm lg:text-base w-full border-1 border-gray-200 rounded bg-gray-50"
                            value={user.username}
                        />
                        <FormPassword 
                            placeholder="Password"
                            type="password"
                            path="password"
                            inputClassName="w-full text-sm lg:text-base border-1 border-gray-200 rounded bg-gray-50"
                            value={state.values.password}
                            error={state.errors.password}
                            onSubmitAction={formActions.submit}
                            {...fieldActions}
                            validator={value => {
                                return authUtil.isStrongPassword(value) ? true : 'Password must include atleast 8 characters, atleast one digit, and atleast one upper case character';
                            }}
                            onChange={(value, path) => {
                                fieldActions.onChange('', 'confirmPassword');
                                fieldActions.onChange(value, path);                            
                            }}
                        />
                        <FormPassword 
                            placeholder="Confirm Password"
                            type="password"
                            path="confirmPassword"
                            inputClassName="w-full text-sm lg:text-base border-1 border-gray-200 rounded bg-gray-50"
                            value={state.values.confirmPassword}
                            error={state.errors.confirmPassword}
                            onSubmitAction={formActions.submit}
                            {...fieldActions}
                            validator={value => state.values.password === value || 'Password confirmation does not match'}
                        />
                        <FormError value={state.formError} />
                        <div className="flex items-center mt-4">
                            <button 
                                className="ml-auto py-2 px-4 focus:outline-none rounded-full text-white text-sm bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed" 
                                onClick={formActions.submit}
                                disabled={!state.isValid}
                            >
                                Submit
                            </button>
                            <Link 
                                to="/login"
                                className="ml-3 py-2 px-4 focus:outline-none border border-gray-100 rounded-full text-blueGray-100 text-sm bg-gray-100 font-semibold"
                            >
                                Cancel
                            </Link>
                        </div>
                        <p className="text-sm mt-8">Open M-F 8:00 AM to 8:00 PM, Saturday 9:00 AM to 1:00 PM</p>
                        <div className="flex items-center text-gray-400 text-sm mt-1">
                            <a href='tel:9192770123' className="flex items-center mr-4">
                                <MdCall size="1.125rem" className="mr-1"/>
                                (919) 277-0123
                            </a>
                            <a href='mailto:orders@tryontitle.com' className="flex items-center">
                                <MdMailOutline size="1.125rem" className="mr-1"/>
                                orders@tryontitle.com
                            </a>
                        </div>
                    </section>
                </Card>
            </div>
        );
};

export default ResetPasswordPage;